module.exports = __webpack_public_path__ + "static/logo-4a8ccca4b140b9a4a7e05b09593eaabd.svg";